<template lang="pug">
.main-item(v-if="show", :class="source.ptype == 30 ? ['c-match', source.categoryId, source.groupId, 'collapse', grouper(source.groupId) == false ? 'show' : ''] : ''")
  small.d-none {{ source.matchId }}

  //- header
  template(v-if="source.ptype == 10")
    .hx-market(:id="source.id", @click="toggleGroup(source.id)")
      template(v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId)")
        template(v-if="mmoMode && menu3 != 'parlay'")
          template(v-if="pageType == 2")
            template(v-if="mmoType == 1")
              hdpou(:source="source")
            template(v-else)
              hdpoum(:source="source")
          template(v-else)
            hdpouslm(:source="source")
        template(v-else)
          template(v-if="pageType == 2")
            hdpou(:source="source")
          template(v-else)
            hdpousl(:source="source")
      hdpouoe(v-if="source.betTypeId == 'hdpou' && [2,25].includes(source.sportsId)", :source="source")
      //- hdpou1x2ft(v-if="source.betTypeId == 'hdpou' && [12].includes(source.sportsId)", :source="source")
      hdpouml(v-if="source.betTypeId == 'hdpou' && [15,19].includes(source.sportsId)", :source="source")
      hdpouoeft(v-if="source.betTypeId == 'hdpou' && [17,18,30].includes(source.sportsId)", :source="source")
      hdpouoe1x2(v-if="source.betTypeId == 'hdpou' && [23,26,27,45,46].includes(source.sportsId)", :source="source")
      hdpouft(v-if="source.betTypeId == 'hdpou' && [29].includes(source.sportsId)", :source="source")
      hdpml(v-if="source.betTypeId == 'hdpou' && [6,8,13].includes(source.sportsId)", :source="source")
      hdpou4d(v-if="source.betTypeId == 'hdpou' && [40].includes(source.sportsId)", :source="source")
      hdpef(v-if="source.betTypeId == 'hdpou' && [41,42,43,44,47].includes(source.sportsId)", :source="source")
      hdpouoeml(v-if="source.betTypeId == 'hdpou' && [3,4,7,9,10,11,12,14,16,20,21,22,24,28,31,32,33,34,35,36,37,38,39].includes(source.sportsId)", :source="source")
      hdpouoeml1x2(v-if="source.betTypeId == 'hdpou' && [5].includes(source.sportsId)", :source="source")

      oxt(v-if="source.betTypeId == 'oxt'", :source="source")
      cs(v-if="source.betTypeId == 'cs'", :source="source")
      oe(v-if="source.betTypeId == 'oe'", :source="source")
      dc(v-if="source.betTypeId == 'dc'", :source="source")
      tg(v-if="source.betTypeId == 'tg'", :source="source")
      htft(v-if="source.betTypeId == 'htft'", :source="source")
      fglg(v-if="source.betTypeId == 'fglg'", :source="source")
      orz(v-if="source.betTypeId == 'orz'", :source="source")

  //- league
  template(v-if="source.ptype == 20")
    template(v-if="mmoMode && menu3 != 'parlay'")
      template(v-if="pageType == 2")
        template(v-if="mmoType == 1")
          league(:source="source")
        template(v-else)
          league(:source="source")
      template(v-else)
        league(:source="source")
    template(v-else)
      league(:source="source")

  //- odd layout
  template(v-if="source.ptype == 30")
    //- small.text-white {{ lmc }}
    template(v-if="mmoMode && menu3 != 'parlay'")
      template(v-if="pageType == 2")
        template(v-if="mmoType == 1")
          hdpouMMO(v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
        template(v-else)
          hdpouMMO2(v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
      template(v-else)
        hdpouslMMO(v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source")
    template(v-else)
      template(v-if="pageType == 2")
        hdpouOdds(v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
      template(v-else)
        hdpouslOdds(v-if="source.betTypeId == 'hdpou' && [1].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source")
    hdpouoeOdds(v-if="source.betTypeId == 'hdpou' && [2,25].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source")
    //-hdpou1x2ftOdds(v-if="source.betTypeId == 'hdpou' && [12].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
    hdpmlOdds(v-if="source.betTypeId == 'hdpou' && [6,8,13].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
    hdpoumlOdds(v-if="source.betTypeId == 'hdpou' && [15,19].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
    hdpouftOdds(v-if="source.betTypeId == 'hdpou' && [29].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
    hdpouoeftOdds(v-if="source.betTypeId == 'hdpou' && [17,18,30].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
    hdpouoe1x2Odds(v-if="source.betTypeId == 'hdpou' && [23,26,27,45,46].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source", :single="single")
    hdpouoemlOdds(
      v-if="source.betTypeId == 'hdpou' && [3,4,7,9,10,11,12,14,16,20,21,22,24,28,31,32,33,34,35,36,37,38,39].includes(source.sportsId) && source.hasOwnProperty('details')", 
      :index="index",
      :source="source",
      :single="single"
    )
    hdpouoeml1x2Odds(
      v-if="source.betTypeId == 'hdpou' && [5].includes(source.sportsId) && source.hasOwnProperty('details')", 
      :index="index",
      :source="source",
      :single="single"
    )
    hdpouoemlOdds1(v-if="source.betTypeId == 'hdpou' && source.marketId == 3 && [20].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source")
    hdpouoemlOdds2(v-if="source.betTypeId == 'hdpou' && source.marketId != 3 && [20].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source")
    hdp4dOdds(v-if="source.betTypeId == 'hdpou' && [40].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source")
    hdpouoemlOdds3(v-if="source.betTypeId == 'hdpou' && [41,42,43,44,47].includes(source.sportsId) && source.hasOwnProperty('details')", :index="index", :source="source")
    oxtOdds(v-if="source.betTypeId == 'oxt' && source.hasOwnProperty('details')", :index="index", :source="source")
    oeOdds(v-if="source.betTypeId == 'oe' && source.hasOwnProperty('details')", :index="index", :source="source")
    csOdds(v-if="source.betTypeId == 'cs' && source.hasOwnProperty('details')", :index="index", :source="source")
    dcOdds(v-if="source.betTypeId == 'dc' && source.hasOwnProperty('details')", :index="index", :source="source")
    tgOdds(v-if="source.betTypeId == 'tg' && source.hasOwnProperty('details')", :index="index", :source="source")
    htftOdds(v-if="source.betTypeId == 'htft' && source.hasOwnProperty('details')", :index="index", :source="source")
    fglgOdds(v-if="source.betTypeId == 'fglg' && source.hasOwnProperty('details')", :index="index", :source="source")
    orzOdds(v-if="source.betTypeId == 'orz' && source.hasOwnProperty('details')", :index="index", :source="source")
</template>

<script>
import league from "@/components/desktop/main/xheader/league";

// header
import hdpou from "@/components/desktop/main/xheader/hdpou";
import hdpoum from "@/components/desktop/main/xheader/hdpoum";
import hdpousl from "@/components/desktop/main/xheader/hdpousl";
import hdpouslm from "@/components/desktop/main/xheader/hdpouslm";
import hdpouoe from "@/components/desktop/main/xheader/hdpouoe";
import hdpouml from "@/components/desktop/main/xheader/hdpouml";
import hdpouft from "@/components/desktop/main/xheader/hdpouft";
import hdpouoeft from "@/components/desktop/main/xheader/hdpouoeft";
import hdpouoe1x2 from "@/components/desktop/main/xheader/hdpouoe1x2";
import hdpou1x2ft from "@/components/desktop/main/xheader/hdpou1x2ft";
import hdpouoeml from "@/components/desktop/main/xheader/hdpouoeml";
import hdpouoeml1x2 from "@/components/desktop/main/xheader/hdpouoeml1x2";
import hdpef from "@/components/desktop/main/xheader/hdpef";
import hdpml from "@/components/desktop/main/xheader/hdpml";
import hdpou4d from "@/components/desktop/main/xheader/hdpou4d";
import oxt from "@/components/desktop/main/xheader/oxt";
import cs from "@/components/desktop/main/xheader/cs";
import oe from "@/components/desktop/main/xheader/oe";
import dc from "@/components/desktop/main/xheader/dc";
import tg from "@/components/desktop/main/xheader/tg";
import htft from "@/components/desktop/main/xheader/htft";
import fglg from "@/components/desktop/main/xheader/fglg";
import orz from "@/components/desktop/main/xheader/orz";

// mmo
import hdpouMMO from "@/components/desktop/main/mmo/hdpouMMO";
import hdpouMMO2 from "@/components/desktop/main/mmo/hdpouMMO2";
import hdpouslMMO from "@/components/desktop/main/mmo/hdpouslMMO";

// table
import hdpouOdds from "@/components/desktop/main/xtable/hdpouOdds";
import hdpouslOdds from "@/components/desktop/main/xtable/hdpouslOdds";
import hdpouoeOdds from "@/components/desktop/main/xtable/hdpouoeOdds";
import hdpou1x2ftOdds from "@/components/desktop/main/xtable/hdpou1x2ftOdds";
import hdpouoe1x2Odds from "@/components/desktop/main/xtable/hdpouoe1x2Odds";
import hdpouftOdds from "@/components/desktop/main/xtable/hdpouftOdds";
import hdpouoeftOdds from "@/components/desktop/main/xtable/hdpouoeftOdds";
import hdpouoemlOdds from "@/components/desktop/main/xtable/hdpouoemlOdds";
import hdpouoemlOdds1 from "@/components/desktop/main/xtable/hdpouoemlOdds1";
import hdpouoemlOdds2 from "@/components/desktop/main/xtable/hdpouoemlOdds2";
import hdpouoemlOdds3 from "@/components/desktop/main/xtable/hdpouoemlOdds3";
import hdpouoeml1x2Odds from "@/components/desktop/main/xtable/hdpouoeml1x2Odds";
import hdpoumlOdds from "@/components/desktop/main/xtable/hdpoumlOdds";
import hdpmlOdds from "@/components/desktop/main/xtable/hdpmlOdds";
import hdp4dOdds from "@/components/desktop/main/xtable/hdp4dOdds";
import csOdds from "@/components/desktop/main/xtable/csOdds";
import oxtOdds from "@/components/desktop/main/xtable/oxtOdds";
import oeOdds from "@/components/desktop/main/xtable/oeOdds";
import dcOdds from "@/components/desktop/main/xtable/dcOdds";
import tgOdds from "@/components/desktop/main/xtable/tgOdds";
import htftOdds from "@/components/desktop/main/xtable/htftOdds";
import fglgOdds from "@/components/desktop/main/xtable/fglgOdds";
import orzOdds from "@/components/desktop/main/xtable/orzOdds";

export default {
  components: {
    league,
    hdpou,
    hdpoum,
    hdpousl,
    hdpouslm,
    hdpouoe,
    hdpouml,
    hdpouft,
    hdpouoeft,
    hdpouoe1x2,
    hdpou1x2ft,
    hdpouoeml,
    hdpouoeml1x2,
    hdpef,
    hdpml,
    hdpou4d,
    oxt,
    cs,
    oe,
    dc,
    tg,
    htft,
    fglg,
    orz,

    hdpouMMO,
    hdpouMMO2,
    hdpouslMMO,

    hdpouOdds,
    hdpoumlOdds,
    hdpouslOdds,
    hdpouoeOdds,
    hdpou1x2ftOdds,
    hdpouoe1x2Odds,
    hdpouftOdds,
    hdpouoeftOdds,
    hdpouoemlOdds,
    hdpouoemlOdds1,
    hdpouoemlOdds2,
    hdpouoemlOdds3,
    hdpouoeml1x2Odds,
    hdpmlOdds,
    hdp4dOdds,
    csOdds,
    oxtOdds,
    oeOdds,
    dcOdds,
    tgOdds,
    htftOdds,
    fglgOdds,
    orzOdds,
  },
  props: {
    index: {
      type: Number,
    },
    source: {
      type: Object,
      default() {
        return {};
      },
    },
    single: {
      type: Boolean,
      default: false,
    },
    lmc: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timer: null,
      show: false,
    };
  },
  computed: {
    mmoMode() {
      return this.$store.getters.mmoMode;
    },
    parlayMode() {
      return this.$store.state.cache.parlayMode;
    },
    menuX() {
      return this.$store.state.layout.menuX;
    },
    menu3() {
      return this.$store.state.layout.menu3;
    },
    pageType() {
      return this.$store.getters.pageDisplay.pageType;
    },
    mmoType() {
      return this.$store.getters.pageDisplay.mmoType;
    },
    selectLeague() {
      return this.$store.getters.selectLeague;
    },
    leagueFiltered() {
      return this.$store.state.layout.leagueFiltered;
    },
  },
  mounted() {
    if (this.source.marketId == 3 || this.menuX) {
      this.show = true;
    } else {
      if (this.$store.getters.menu1 == "today") {
        var timing = 500;
        if (this.$store.getters.menu2 == 1 && !["orz", "parlay"].includes(this.$store.getters.menu3)) {
          if (this.lmc > 10) {
            timing = 2500 + this.lmc * 5;
          }
        }
        setTimeout(() => {
          this.show = true;
        }, timing);
      } else {
        this.show = true;
      }
    }
  },
  methods: {
    grouper(e) {
      var test = $("#" + e).hasClass("collapsed");
      return test;
    },
    toggleGroup(e) {
      // console.log("toggleGroup");
      var ln = $(".c-league." + e);
      var m = $(".c-match." + e);

      var elem = $("#" + e);
      if (elem.hasClass("collapsed")) {
        elem.removeClass("collapsed").attr("aria-expanded", "true");
        ln.removeClass("collapsed").attr("aria-expanded", "true");
        setTimeout(() => {
          m.addClass("show");
        }, 100);
      } else {
        elem.addClass("collapsed").attr("aria-expanded", "false");
        ln.addClass("collapsed").attr("aria-expanded", "false");
        setTimeout(() => {
          m.removeClass("show");
        }, 100);
      }
    },
  },
};
</script>
